<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible'
             width='600px' center
             :close-on-click-modal='false'>
    <div class='company'>
          <el-form :model='addForm' :rules="rules" label-width='100px' :inline='true' ref="addFenceForm">
            <el-row>
              <el-col :span='12'>
                <el-form-item label='区域名称：'>
                  <el-input v-model='addForm.regionName' size='mini'
                            placeholder='请输入区域名称'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='围栏名称：'>
                  <el-input v-model='addForm.fenceName' size='mini'
                            placeholder='请输入围栏名称'></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
      <div class='btnContainer'>
        <el-button class='searchBtn' :loading='loading' @click='addClick' size='small'>确定
        </el-button>
        <el-button class='resetBtn' @click='dialogClose' size='small'>关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {addElectronicFence} from "@/service/DevOps";
import {clearAll} from "@/service/fence";
export default {
  data(){
    return{
      dialogTitle:'新增',
      dialogVisible: false,
      loading:false,
      addForm:{
        regionName:'',
        fenceName:'',
        regionId: '',
        fenceId: '',
        longLatitude:'',
        isEnable: '',
        isDelete: '',
        createTime: '',
        page: '',
        rows: '',
      },
      rules:{
        regionName: [
          {
            required: true,
            message: '请输入区域名称',
            trigger: 'blur',
          },
        ],
        fenceName: [
          {
            required: true,
            message: '请输入围栏名称',
            trigger: 'blur',
          },
        ],
      }
    }
  },
  methods:{
    dialogOpen(fenceData) {
      this.addForm.longLatitude = fenceData.points;
      this.dialogVisible = true;
      console.log(fenceData.points)
    },
    //确认
    async addClick(){
      this.loading = true;
      const {
        status,
        message,
      } = await addElectronicFence(this.addForm);
      this.loading = false;
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
      this.$emit('success')
      this.dialogClose()
    },
    //重置表单
    resetForm() {
      this.$refs.addFenceForm.resetFields();
    },
    //弹窗关闭
    dialogClose(){
      this.dialogVisible = false
      clearAll();
      this.resetForm();
    },
  }
}
</script>
